import React, { useEffect, useState } from 'react'
import Select from 'react-select';
import { JSON_ONE, JSON_TWO, JSON_THREE } from "./JSON_DATA";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import ReactJson from 'react-json-view'
import { CopyToClipboard } from 'react-copy-to-clipboard';
function Usecases() {
const [OptionData, SetOptionData] = useState([])
const [selectedOption, SetselectedOption] = useState([])
const [TabCheck, SetTabCheck] = useState(false)
const [CollapseExpand, SetCollapseExpand] = useState(false);
const [StateForCopy, SetStateForCopy] = useState()
useEffect(() => {
const options = [
{ value: '1', label: 'version Check Request' },
{ value: '2', label: 'load Money Request' },
{ value: '3', label: 'load Money List Request' },
{ value: '4', label: 'get Beneficiary List Request' },
{ value: '5', label: 'validate OTP Req' },
{ value: '6', label: 'transactions By Day Req' },
{ value: '7', label: 'transactions By Customer Id Req' },
{ value: '8', label: 'transactions By Transaction Id Req' },
];
SetOptionData(options)
SetselectedOption({ value: '1', label: 'version Check Request' })
}, [])
const onChangeSelected = (data) => {
SetselectedOption(data)
SetCollapseExpand(false)
}
const onClickCangeTab = () => {
SetTabCheck(!TabCheck);
}
useEffect(() => {
if (selectedOption.value == 1) {
SetStateForCopy(JSON.stringify(JSON_ONE, null, 2));
} else if (selectedOption.value == 2) {
SetStateForCopy(JSON.stringify(JSON_TWO, null, 2));
} else if (selectedOption.value == 3) {
SetStateForCopy(JSON.stringify(JSON_THREE, null, 2));
} else {
SetStateForCopy("");
}
}, [selectedOption])
const funJSON_DATA = () => {
if (selectedOption.value == 1) {
return (
<pre>
                    {/* {JSON.stringify(JSON_ONE, null, 2)} */}
                    <ReactJson src={JSON_ONE} collapsed={CollapseExpand} />
                </pre>
)
} else if (selectedOption.value == 2) {
// SetStateForCopy(JSON_TWO);
return (
<pre>
                    {/* {JSON.stringify(JSON_TWO, null, 2)} */}
                    <ReactJson src={JSON_TWO} collapsed={CollapseExpand} />
                </pre>
)
} else if (selectedOption.value == 3) {
// SetStateForCopy(JSON_THREE);
return (
<pre>
                    {/* {JSON.stringify(JSON_THREE, null, 2)} */}
                    <ReactJson src={JSON_THREE} collapsed={CollapseExpand} />
                </pre>
)
} else {
// SetStateForCopy("");
return (
<div>
   No Data
</div>
)
}
}
const onClickExpandAll = () => {
SetCollapseExpand(false)
}
const onClickCollapseAll = () => {
SetCollapseExpand(true)
}
return (
<div class="idocs-content">
   <div class="container">
      <div class="row">
      </div>
      <div class="row">
         <div class="col-md-8">
            <section id="idocs_content">
              
               <h1>Use cases</h1>
               <hr />
               <p class="mt-30">Our payout solutions cater to a wide range of use cases, such as: </p>
               <ul>
                  <li>Salary payments for businesses to transfer funds directly to their employees' bank accounts, reducing manual processing.</li>
                  <li>Vendor payments for businesses to make payments to their suppliers, vendors, and service providers.</li>
                  <li>Refunds for quickly and efficiently processing refunds for customers.</li>
                  <li>Cashback offers for transferring cashback amounts to customers' accounts or wallets as a way to incentivize purchases.</li>
                  <li>Freelance payments for paying freelancers for their services directly to their bank accounts or digital wallets.</li>
                  <li>Insurance claims for insurance companies to transfer claims to their customers quickly and reduce manual processing.</li>
                  <li>Government payments for the Indian government to transfer various benefits to citizens such as subsidies, pensions, and scholarships efficiently and securely.</li>
               </ul>
               <p>
                  Say goodbye to manual processing and paper checks and switch to our digital payout solutions today.
               </p>
            </section>
         </div>
         <div class="col-md-4">
           
        
       
        
      </div>
   </div>
</div>
</div>
)
}
export default Usecases